import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Key } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ChangePassword() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('كلمتا المرور غير متطابقتين');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/auth/change-password`, {
        old_password: oldPassword,
        new_password: newPassword,
      });
      toast.success('تم تحديث كلمة المرور بنجاح');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => navigate('/dashboard'), 800);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'فشل تحديث كلمة المرور');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-6" data-testid="change-password-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-black text-primary">تغيير كلمة المرور</h1>
        <p className="text-muted-foreground mt-1">قم بتحديث كلمة المرور الخاصة بحسابك</p>
      </div>

      <Card className="p-8 border-border">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-12 w-12 rounded-lg bg-brand_blue/10 flex items-center justify-center">
            <Key className="h-6 w-6 text-brand_blue" />
          </div>
          <div>
            <h2 className="text-xl font-bold">معلومات أمان الحساب</h2>
            <p className="text-sm text-muted-foreground">للتحقق، أدخل كلمة المرور الحالية</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="old-password" className="font-bold">كلمة المرور الحالية</Label>
            <Input
              id="old-password"
              data-testid="old-password-input"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="text-right h-11"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="new-password-field" className="font-bold">كلمة المرور الجديدة</Label>
            <Input
              id="new-password-field"
              data-testid="new-password-field"
              type="password"
              placeholder="6 أحرف على الأقل"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="text-right h-11"
              required
              minLength={6}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="confirm-password" className="font-bold">تأكيد كلمة المرور الجديدة</Label>
            <Input
              id="confirm-password"
              data-testid="confirm-password-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="text-right h-11"
              required
            />
          </div>

          <div className="flex gap-3 justify-end pt-2">
            <Button
              type="button"
              variant="ghost"
              onClick={() => navigate('/dashboard')}
            >
              إلغاء
            </Button>
            <Button
              type="submit"
              data-testid="submit-change-password"
              disabled={submitting}
              className="px-8"
            >
              {submitting ? 'جاري التحديث...' : 'تحديث كلمة المرور'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
